/**
 * The governed vocabularies, read for the deal screens.
 *
 * `ReferenceDataSettingsTab` curates these lists; until now nothing on a deal
 * screen read them back, so the desk free-typed the same five fields the
 * 0.85 near-duplicate matcher then had to clean up. Free text is what creates
 * the near-duplicates.
 *
 * Values only — the deal columns are bare strings with no foreign key
 * (`models/loan.py`), so a slot needs the vocabulary, not the entity.
 */
import api from './api'

export interface ReferenceEntry {
  id: string
  category: string
  value: string
  normalizedValue: string
  isActive: boolean
  notes: string
}

export const referenceDataService = {
  /**
   * Active entries for one category, already ordered by the server (active
   * first, then alphabetical).
   *
   * Note the lists ship EMPTY by design — they are seeded from the client's
   * verified list, never invented here — so an empty array is the ordinary
   * state on a new account, not a failure. Callers must stay usable when it is.
   */
  listValues: (category: string): Promise<string[]> =>
    api
      .get<{ entries: ReferenceEntry[] }>('/reference-data', { params: { category } })
      .then((r) => (r.data.entries ?? []).filter((e) => e.isActive).map((e) => e.value)),
}
